if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      const idInput = this.form.querySelector('[name="id"], [name="id[]"]');
      if (idInput) idInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-items');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message
            }}));
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if(!this.error) {
            this.error = false;
            pushSuccessMessage(window.cartStrings.success);
            // try {
            //   console.log("c_id ",formData.get('id'));
            //   if(localStorage.getItem("alreadyAddedProduct")){
            //     let arrPro = JSON.parse(localStorage.getItem("alreadyAddedProduct"))
            //     if(!arrPro.includes(''+formData.get('id')+'')){
            //       arrPro.push(formData.get('id'));
            //       localStorage.setItem("alreadyAddedProduct", JSON.stringify(arrPro)); 
            //     }
            //   }else{
            //     localStorage.setItem("alreadyAddedProduct", '["'+formData.get('id')+'"]')
            //   }
            //   const getData = (callback) => {
            //       const xhttp = new XMLHttpRequest();
            //       xhttp.responseType = 'json';
            //       xhttp.open("GET", "/cart.js");
            //       xhttp.send();
            //       xhttp.onreadystatechange = function() {
            //           if (xhttp.readyState === 4 && xhttp.status === 200) {
            //               let data = this.response;
            //               if(data.items.findIndex(item => item.variant_id == "42571488788655")==-1){
            //                   callback(undefined, true);
            //               }else{
            //                   callback("error ",undefined);
            //               }
            //           }
            //       }
            //   }
              
            //   getData((err, data) => {
            //     console.log("callback Data===> ", data);
            //     if (data) {
            //       if(formData.get('isEnvTag') == "true"){
            //         let cstmQnty = 1;
            //         // if(formData.get('quantity')){
            //         //   cstmQnty = formData.get('quantity');
            //         // }
            //         fetch(window.Shopify.routes.root + 'cart/add.js', {
            //           method: 'POST',
            //           headers: {
            //           'Content-Type': 'application/json'
            //           },
            //           body: JSON.stringify({ 'items': [{ 'id': 42571488788655, 'quantity': cstmQnty }] })
            //         }).then(response => {
            //           localStorage.setItem("envFeeAdded", "yes")
            //           setTimeout(function(){
            //             window.location.reload();
            //           },800)
            //           // return response.json();
            //         }).catch((error) => {
            //           console.error('Error:', error);
            //         });
            //       }
            //     }
            //   });
              
            // } catch (error) {
            //   console.error('Error_cstm_product-form:', error);
            // }
            const quickAddDrawer = this.closest('quick-add-drawer');
            if (quickAddDrawer) {
              document.body.addEventListener('drawerClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddDrawer.close();
            } else {
              this.cart.renderContents(response);
            }
            document.dispatchEvent(new CustomEvent('afterCartChanged', {detail: {productVariantId: formData.get('id')}}));
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if(errorMessage && !this.errorMessageWrapper) {
        pushErrorMessage(errorMessage);
      }
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


